import { TreeItemContent, TreeItemRoot } from '@mui/x-tree-view';
import styled, { css } from 'styled-components';

export const MuiTreeItemRoot = styled(TreeItemRoot)<{
  $borderTop: boolean;
  $borderBottom: boolean;
}>`
  &[aria-expanded='true'] {
    padding-bottom: ${({ theme }) => theme.spacing(2)};
  }

  ${({ theme, $borderTop }) =>
    $borderTop &&
    css`
      &:before {
        content: '';
        display: block;
        height: 1px;
        width: calc(100% - ${theme.spacing(4)});
        margin: ${theme.spacing(1)} ${theme.spacing(2)};

        background: ${theme.palette.divider};
      }
    `};

  ${({ theme, $borderBottom }) =>
    $borderBottom &&
    css`
      &:after {
        content: '';
        display: block;
        height: 1px;
        width: calc(100% - ${theme.spacing(4)});
        margin: ${theme.spacing(1)} ${theme.spacing(2)};

        background: ${theme.palette.divider};
      }
    `};
`;

export const MuiTreeItemContent = styled(TreeItemContent)`
  padding: ${({ theme }) =>
    `0 0 0 calc(${theme.spacing(2)} * var(--TreeView-itemDepth))`};

  &:hover {
    background: ${({ theme }) => theme.palette.background.default};
  }

  &[data-focused] {
    background: ${({ theme }) => theme.palette.background.default};
  }
`;

export const CustomItemContainer = styled.div<{ $hasBorderBottom: boolean }>`
  flex: 1;
  min-width: 0;

  ${({ $hasBorderBottom, theme }) =>
    $hasBorderBottom &&
    css`
      &:after {
        content: '';
        display: block;
        height: 1px;
        width: calc(100% - ${theme.spacing(4)});
        margin: 0 ${theme.spacing(2)};

        background: ${theme.palette.divider};
      }
    `};
`;
